module.exports = __webpack_public_path__ + "img/meetabout_logo.9dfbec38.png";